export const getConsultantLogoUrl = () =>
  localStorage.getItem("consultantLogoUrl") || null;

// Square mark for tight/collapsed spaces (the sidebar rail) — distinct from
// getConsultantLogoUrl(), which is the landscape wordmark shown wherever
// there's room for it (e.g. the hover-expanded sidebar panel).
export const getConsultantIconUrl = () =>
  localStorage.getItem("consultantIconUrl") || null;

export const getConsultantCompanyName = () =>
  localStorage.getItem("consultantCompanyName") || null;

// Branding is only "live" once both a logo and a name are set (see
// WhiteLabeling.jsx) — same gating already used in PolicyPage/TermsOfServices,
// applied here to the browser tab title too.
export const getBrowserTabTitle = () =>
  `${(getConsultantLogoUrl() && getConsultantCompanyName()) || "Vajra"} | ESG Platform`;

// Browser-tab icon follows the same gating as the tab title: the consultant's
// uploaded icon replaces the Vajra favicon only once branding is live.
export const applyBrowserFavicon = () => {
  const iconUrl =
    getConsultantLogoUrl() && getConsultantCompanyName()
      ? getConsultantIconUrl()
      : null;
  const href = iconUrl || "/vajra.svg";
  document
    .querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"]')
    .forEach((link) => {
      link.setAttribute("href", href);
      if (iconUrl) link.removeAttribute("type");
      else link.setAttribute("type", "image/svg+xml");
    });
};
